import { Avatar } from "@/atoms"
import { getColorNumberForUserAvatar, getInitials } from "@/domain/user"
import { Kodem } from "@/icons"
import { DismissedByLabel } from "./DismissedByLabel"
import styles from "./DismissedTag.module.scss"
import { DismissedByComponent } from "./DismissedTag.types"

export const DismissedBy: DismissedByComponent = (props) => {
  const { dismissMethod, dismissedBy, t } = props
  const isManual = dismissMethod === "manual"

  return (
    <div className={styles.dismissContainer}>
      {isManual ? (
        <Avatar
          style={{
            backgroundColor: `var(--color-${getColorNumberForUserAvatar(dismissedBy)}-avatar-palette)`
          }}
          className={styles.avatar}
          size="small"
        >
          {`${getInitials(dismissedBy)}`}
        </Avatar>
      ) : (
        <Kodem className={styles.kodemIcon} />
      )}
      <DismissedByLabel
        dismissedBy={dismissedBy}
        dismissMethod={dismissMethod}
        t={t}
      />
    </div>
  )
}
